/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import DiabeticForm from '../forms/DiabeticForm/DiabeticForm';
import { Box, Paper, Typography, useScrollTrigger } from '@mui/material';
import FootForm from '../forms/FootForm/FootForm';
import useMasterApi from '../../services/useMasterApi';
import { ENDPOINT } from '../../services/endPoints';
import CustomLoader from '../../components/CustomLoader/CustomLoader';
import PatientImages from '../forms/PatientImages';
import DoctorCommentsForm from '../forms/DoctorCommentsForm/DoctorCommentsForm';

const RecordForm = () => {
  const {user_form_id} = useParams();
  const {getWithQueryParams, data, error, loading} = useMasterApi()
  const location = useLocation();
    
  const { form_code, formType, form_viewed } = location.state;
  useEffect(()=>{
    getWithQueryParams(`${ENDPOINT.PATIENT_RECORD}/${form_code}`, {form_type: formType} )
  },[form_code])

   if(loading){
    return <CustomLoader/>
  }

    return (
    <>
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
    <Box sx={{  borderRadius: "12px" }} component={Paper} elevation={2}>
      {formType === "2" ? <DiabeticForm formData={data?.formValues}/> : <FootForm formData={data?.formValues} />}
    </Box>
    <PatientImages formData={data?.formImages?.values?.rows}/>
      <DoctorCommentsForm formData={data?.formValues}/>
      {data?.formValues?.doctore_comments1 && data?.formValues?.doctore_comments1 !== "" && <Box sx={{ display:"flex", flexDirection: "column", gap: "0.5rem" }}>
      <Typography variant='h1' color="primary" sx={{fontWeight:"bold", textAlign: "center", textDecoration:"underline" }}>Rejection Reason:
       </Typography>
       <Typography variant='h2' color="error" sx={{fontWeight:"bold", textAlign: "center"}}>{data?.formValues?.doctore_comments1}
       </Typography>
       </Box>}
      </Box>
    </>
  )
}

export default RecordForm